<div class="star-rating">
  @if (hasSvg) { @for (item of stars; track $index) {
  <img src="../../../../assets/icons/star-favorite.svg" alt="" />
  } } @else { @for (item of stars; track $index) {
  <i class="fas fa-star"></i>
  } @for (item of rest; track $index) {
  <i class="far fa-star"></i>
  } }
</div>
